import React from 'react'

import PropTypes from 'prop-types'

import AtomButton, {
  atomButtonDesigns,
  atomButtonShapes,
  atomButtonSizes,
  atomButtonTypes
} from '@s-ui/react-atom-button'

const HeroBasicCTA = ({cta}) => {
  const {design = atomButtonDesigns.LINK, onClick = () => {}, text, type, url} = cta

  return (
    <AtomButton
      design={design}
      href={url}
      link={Boolean(url)}
      onClick={onClick}
      size={atomButtonSizes.LARGE}
      type={type}
      shape={atomButtonShapes.CIRCULAR}
      color="accent"
    >
      {text}
    </AtomButton>
  )
}

HeroBasicCTA.propTypes = {
  cta: PropTypes.shape({
    design: PropTypes.oneOf(Object.values(atomButtonDesigns)),
    onClick: PropTypes.func,
    text: PropTypes.string,
    type: PropTypes.oneOf(Object.values(atomButtonTypes)),
    url: PropTypes.string
  })
}

export {atomButtonDesigns as heroBasicCTADesigns, atomButtonTypes as heroBasicCTATypes}

export default HeroBasicCTA
